import { jsonGet, jsonPost, jsonPut } from "../api";

export const fetchBrandKit = async (brandId) =>
  await jsonGet(`brands/${brandId}/kit`);

export const updateBrandKit = async (brandId, data) =>
  await jsonPut(`brands/${brandId}/kit`, data);

export const generateBrandKit = async (brandId) =>
  await jsonPost(`brands/${brandId}/kit/generate`);

export const generateVisualStyle = async (brandId) =>
  await jsonPost(`brands/${brandId}/kit/generate-visual-style`);
